export const findEarliestKickoff = (fixtures) => {
	if (fixtures.length === 0) {
		return new Date().toISOString();
	}

	const kickoffTimes = fixtures.map((fixture) => new Date(fixture.kickoffAt));
	const earliestKickoff = new Date(Math.min(...kickoffTimes.map((kickoff) => kickoff.getTime())));

	// Subtract 15 minutes from the earliest kickoff
	earliestKickoff.setMinutes(earliestKickoff.getMinutes() - 15);

	return earliestKickoff.toISOString();
};

export const calculateTimeLeft = (datetime) => {
	const deadline = new Date(datetime);
	const now = new Date();
	const difference = deadline.getTime() - now.getTime();

	let timeLeft = {
		days: "00",
		hours: "00",
		minutes: "00",
	};

	if (difference > 0) {
		timeLeft = {
			days: String(Math.floor(difference / (1000 * 60 * 60 * 24))).padStart(2, "0"),
			hours: String(Math.floor((difference / (1000 * 60 * 60)) % 24)).padStart(2, "0"),
			minutes: String(Math.floor((difference / 1000 / 60) % 60)).padStart(2, "0"),
		};
	}

	return timeLeft;
};

export const formatDateForDeadline = (date) => {
	const options = { day: "2-digit", month: "short" };
	const datePart = date.toLocaleDateString("en-GB", options);
	const timePart = date.toLocaleTimeString("en-GB", { hour: "2-digit", minute: "2-digit" });
	return `${datePart} at ${timePart}`;
};
